import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
export class ScrollService {

    scroll = new BehaviorSubject('');

    scrollToElement(el: HTMLElement){
        el.scrollIntoView({block: 'start'});
      }

    scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
  }
